<template>
    <section>
        <div class="position-fixed fadeIn show shadow-sm rounded w-auto" :class="minimize ? 'custom-toast-minimized' : 'custom-toast'" :style="styles">
            <div class="p-1" v-if="!minimize">
                <div class="header">
                    <span>
                        <i style="font-size: 20px; color: #c9b905;" class="fa fa-lightbulb-o ml-1 mr-2" />
                        <b>Help</b>
                    </span>
                    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close" @click="minimize = true">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="toast-body p-1 px-2">
                    <div v-for="(item, i) in helps" :key="i">
                        <a class="d-inline-block" target="_blank" :href="`/guides/instruction/${encodeURIComponent(item.instruction)}`" v-html="item.label"/>
                    </div>
                </div>

            </div>
            <div v-else>
                <div class="header p-1">
                    <span>
                        <i style="font-size: 20px; color: #c9b905;" class="fa fa-lightbulb-o ml-1 mr-1" />
                        <b>Help</b>
                    </span>
                    <button type="button" class="ml-3 mr-1 close" data-dismiss="toast" aria-label="Close" @click="minimize = false">
                        <i class="fa fa-expand" style="font-size: 17px; vertical-align: middle;"/>
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default {
    name: 'HelperModal',

    props: [
        'helps',
        'styles',
    ],

    components: {
    },

    data() {
        return {
            minimize: true,
            instruction: ''
        }
    },

    async created() {},

    methods: {
        showInstruction(instruction)
        {
            this.instruction = instruction

            setTimeout(() => {
                window.$('#static-instruction-modal').modal('show')
            }, 100);
        }
    }

}
</script>
